import Vue from 'vue'
import Router from 'vue-router' 


import HomeIndex from './views/Home/Index.vue'
import ProfileIndex from './views/Profile/Index.vue'

import WebNetminSubdomains from './views/Web/Netmin/Subdomains.vue'
import WebChecklistIndex from './views/Web/Checklist/Index.vue'
import WebProxiesIndex from './views/Web/Proxies/Index.vue'

import PlatformAccountsIndex from './views/Platform/Accounts/Index.vue'

import ServerDomains from './views/Server/Domains.vue'
import ServerCrons from './views/Server/Crons.vue'
import ServerSuspended from './views/Server/Suspended.vue'
import ServerExpired from './views/Server/Expired.vue'

import SocialmediaCron from './views/Socialmedia/Cron.vue'
import SocialmediaCekilisIndex from './views/Socialmedia/Cekilis/Index.vue'
import SocialmediaCekilisDetail from './views/Socialmedia/Cekilis/Detail.vue'


import WorkManagerIndex from './views/WorkManager/Index.vue'

import EmailIndex from './views/Email/Index.vue'
import EmailUsers from './views/Email/Users.vue'
import EmailEdit from './views/Email/Edit.vue'
import EmailGroupEdit from './views/Email/GroupEdit.vue'


import DesignSiteIndex from './views/Design/Site/Index.vue'
import DesignSiteEdit from './views/Design/Site/Edit.vue'
import DesignLogoIndex from './views/Design/Logo/Index.vue'
import DesignLogoEdit from './views/Design/Logo/Edit.vue'

import ServicesSmsIndex from './views/Services/Sms.vue'

import UsersGroupsIndex from './views/Users/Groups/Index.vue'
import UsersUsersIndex from './views/Users/Users/Index.vue'

import TeklifCustomers from './views/Teklif/Customers.vue'
import TeklifCategories from './views/Teklif/Categories.vue'
import TeklifProducts from './views/Teklif/Products.vue'
import TeklifOffers from './views/Teklif/Offers.vue'
import TeklifOffersOffer from './views/Teklif/Offer.vue'
import TeklifSettings from './views/Teklif/Settings.vue'





import ModulesSanalsantral from './views/Modules/Sanalsantral.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [ 
		{
			path: '/',
			name: 'HomeIndex',
			component: HomeIndex
		},
		{
			path: '/profile',
			name: 'ProfileIndex',
			component: ProfileIndex
		},

		{
			path: '/platform/accounts',
			name: 'PlatformAccountsIndex',
			component: PlatformAccountsIndex
		},


		{
			path: '/web/netmin/subdomains',
			name: 'WebNetminSubdomains',
			component: WebNetminSubdomains
		},
		{
			path: '/web/checklist',
			name: 'WebChecklistIndex',
			component: WebChecklistIndex
		},
		{
			path: '/web/proxies',
			name: 'WebProxiesIndex',
			component: WebProxiesIndex
		},


		{
			path: '/server/domains',
			name: 'ServerDomains',
			component: ServerDomains
		},
		{
			path: '/server/crons',
			name: 'ServerCrons',
			component: ServerCrons
		},
		{
			path: '/server/suspended',
			name: 'ServerSuspended',
			component: ServerSuspended
		},
		{
			path: '/server/expired',
			name: 'ServerExpired',
			component: ServerExpired
		},


		{
			path: '/socialmedia/cron',
			name: 'SocialmediaCron',
			component: SocialmediaCron
		},
		{
			path: '/socialmedia/cekilis',
			name: 'SocialmediaCekilisIndex',
			component: SocialmediaCekilisIndex
		},
		{
			path: '/socialmedia/cekilis/detail',
			name: 'SocialmediaCekilisDetail',
			component: SocialmediaCekilisDetail
		},


		{
			path: '/workmanager',
			name: 'WorkManagerIndex',
			component: WorkManagerIndex
		},


		{
			path: '/modules/sanalsantral',
			name: 'ModulesSanalsantral',
			component: ModulesSanalsantral
		},



		{
			path: '/email',
			name: 'EmailIndex',
			component: EmailIndex
		},
		{
			path: '/email/users',
			name: 'EmailUsers',
			component: EmailUsers
		},
		{
			path: '/email/users/edit',
			name: 'EmailEdit',
			component: EmailEdit
		},
		{
			path: '/email/groups/edit',
			name: 'EmailGroupEdit',
			component: EmailGroupEdit
		},


		{
			path: '/design/site',
			name: 'DesignSiteIndex',
			component: DesignSiteIndex
		},
		{
			path: '/design/site/edit',
			name: 'DesignSiteEdit',
			component: DesignSiteEdit
		},
		{
			path: '/design/logo',
			name: 'DesignLogoIndex',
			component: DesignLogoIndex
		},
		{
			path: '/design/logo/edit',
			name: 'DesignLogoEdit',
			component: DesignLogoEdit
		},

		{
			path: '/services/sms',
			name: 'ServicesSmsIndex',
			component: ServicesSmsIndex
		},


		{
			path: '/users/groups',
			name: 'UsersGroupsIndex',
			component: UsersGroupsIndex
		},
		{
			path: '/users/users',
			name: 'UsersUsersIndex',
			component: UsersUsersIndex
		},


		{
			path: '/teklif/customers',
			name: 'TeklifCustomers',
			component: TeklifCustomers
		},
		{
			path: '/teklif/categories',
			name: 'TeklifCategories',
			component: TeklifCategories
		},
		{
			path: '/teklif/products',
			name: 'TeklifProducts',
			component: TeklifProducts
		},
		{
			path: '/teklif/offers',
			name: 'TeklifOffers',
			component: TeklifOffers
		},
		{
			path: '/teklif/offers/offer',
			name: 'TeklifOffersOffer',
			component: TeklifOffersOffer
		},
		{
			path: '/teklif/settings',
			name: 'TeklifSettings',
			component: TeklifSettings
		},

	]
})